export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);

  newState.isRequesting = payload;

  return newState;
};
